import type { PblCaseStatus } from '@/types/pbl';

export const pblCaseStatusLabelKeys: Record<PblCaseStatus | 'meeing_link_pending', string> = {
  draft: 'pbl.caseStatuses.draft',
  pending_oc_review: 'pbl.caseStatuses.pending_oc_review',
  oc_review_failed: 'pbl.caseStatuses.oc_review_failed',
  initiated: 'pbl.caseStatuses.initiated',
  matching_ready: 'pbl.caseStatuses.matching_ready',
  ai_matching_in_progress: 'pbl.caseStatuses.ai_matching_in_progress',
  ai_matched: 'pbl.caseStatuses.ai_matched',
  manual_assignment_required: 'pbl.caseStatuses.manual_assignment_required',
  lawyer_invited: 'pbl.caseStatuses.lawyer_invited',
  pending_lawyer_response: 'pbl.caseStatuses.pending_lawyer_response',
  lawyer_accepted: 'pbl.caseStatuses.lawyer_accepted',
  lawyer_declined: 'pbl.caseStatuses.lawyer_declined',
  lawyer_timeout: 'pbl.caseStatuses.lawyer_timeout',
  pending_reassignment: 'pbl.caseStatuses.pending_reassignment',
  oc_checking: 'pbl.caseStatuses.oc_checking',
  pending_lawyer_timeslot: 'pbl.caseStatuses.pending_lawyer_timeslot',
  pending_appointment_confirmation: 'pbl.caseStatuses.pending_appointment_confirmation',
  meeting_link_pending: 'pbl.caseStatuses.meeting_link_pending',
  meeing_link_pending: 'pbl.caseStatuses.meeting_link_pending',
  meeting_scheduled: 'pbl.caseStatuses.meeting_scheduled',
  in_progress: 'pbl.caseStatuses.in_progress',
  pending_documents: 'pbl.caseStatuses.pending_documents',
  pending_completion: 'pbl.caseStatuses.pending_completion',
  pending_evaluation: 'pbl.caseStatuses.pending_evaluation',
  closed: 'pbl.caseStatuses.closed',
  appointment_cancelled: 'pbl.caseStatuses.appointment_cancelled',
  case_cancelled: 'pbl.caseStatuses.case_cancelled',
};

export const translatePblCaseStatusLabel = (
  t: (key: string, options?: { defaultValue?: string }) => string,
  backendStatus?: string | null,
  fallback = ''
) => {
  const status = backendStatus?.trim();
  if (!status) return fallback;

  const translationKey = pblCaseStatusLabelKeys[status as keyof typeof pblCaseStatusLabelKeys];
  if (!translationKey) return fallback || status;

  return t(translationKey, { defaultValue: fallback || status });
};
